<template>
  <div class="scrollToTop__wrapper" v-scroll-to="'.app'" v-if="show">
    <icon class="scrollToTop__icon" fill="white" type="angle-up"></icon>
  </div>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  name: 'SearchScrollToTop',

  components: {
    Icon
  },

  data() {
    return {
      show: false
    }
  },

  mounted() {
    document.addEventListener('scroll', this.shouldShow)
  },

  beforeDestroy() {
    document.removeEventListener('scroll', this.shouldShow)
  },

  methods: {
    shouldShow() {
      this.show = window.scrollY > window.innerHeight - 340 ? true : false
    }
  }
}
</script>

<style lang="postcss" scoped>
.scrollToTop__wrapper {
  background-color: var(--color-matisse);
  border-radius: 6px;
  color: var(--color-porcelain);
  cursor: pointer;
  padding: var(--spacing-third);
  position: fixed;
  bottom: var(--spacing-medium);
  right: var(--spacing-medium);

  &:hover {
    background-color: var(--color-eastern-blue);
  }
}

.scrollToTop__icon {
  padding: 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/Search/SearchScrollToTop.vue